import { SubscriptionType } from '../service/Product/ProductService'

export const getColorBySubType = (subType: SubscriptionType): string => {
  switch (subType) {
    case SubscriptionType.FREE:
      return 'free-color'
    case SubscriptionType.BASIC:
      return 'basic-color'
    case SubscriptionType.PREMIUM:
      return 'premium-color'
    default:
      return ''
  }
}
